import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-exportar-excel',
  standalone: true,
  imports: [],
  templateUrl: './icon-exportar-excel.component.html',
  styleUrl: './icon-exportar-excel.component.scss'
})
export class IconExportarExcelComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24px';
}
